const ORDER_OPEN = "open";
const ORDER_PREPARING = "preparing";
const ORDER_DELIVERING = "delivering";
const ORDER_READY = "ready";
const ORDER_COMPLETED = "completed";

const ORDER_FULFILLMENT_DELIVERY = "delivery";
const ORDER_FULFILLMENT_PICKUP = "pickup";

export {
  ORDER_OPEN,
  ORDER_PREPARING,
  ORDER_DELIVERING,
  ORDER_READY,
  ORDER_COMPLETED,
  ORDER_FULFILLMENT_DELIVERY,
  ORDER_FULFILLMENT_PICKUP
};
